"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.OrderNotificationReason = void 0;
var OrderNotificationReason;
exports.OrderNotificationReason = OrderNotificationReason;
(function (OrderNotificationReason) {
  OrderNotificationReason["ALGO_RESTART"] = "ALGO_RESTART";
  OrderNotificationReason["ALGO_STOPPED"] = "ALGO_STOPPED";
  OrderNotificationReason["CANCEL_IN_PROGRESS"] = "CANCEL_IN_PROGRESS";
  OrderNotificationReason["CANCELED"] = "CANCELED";
  OrderNotificationReason["FEED_AVAIL"] = "FEED_AVAIL";
  OrderNotificationReason["FEED_NOT_AVAIL"] = "FEED_NOT_AVAIL";
  OrderNotificationReason["FILLED"] = "FILLED";
  OrderNotificationReason["GATEWAY_AVAIL"] = "GATEWAY_AVAIL";
  OrderNotificationReason["GATEWAY_NOT_AVAIL"] = "GATEWAY_NOT_AVAIL";
  OrderNotificationReason["HUNG_ORDER"] = "HUNG_ORDER";
  OrderNotificationReason["HUNG_ORDER_RESOLVED"] = "HUNG_ORDER_RESOLVED";
  OrderNotificationReason["MARKET_AVAIL"] = "MARKET_AVAIL";
  OrderNotificationReason["NO_MARKET_AVAIL"] = "NO_MARKET_AVAIL";
  OrderNotificationReason["PLACED"] = "PLACED";
  OrderNotificationReason["VENUE_REMOVAL"] = "VENUE_REMOVAL";
})(OrderNotificationReason || (exports.OrderNotificationReason = OrderNotificationReason = {}));
var _default = OrderNotificationReason;
exports.default = _default;